import React, { useState, useRef } from 'react';
import imgErrorFace from '../../assets/faces/error.svg';
import errorIcon from '../../assets/error-icon.svg';
import sendIcon from '../../assets/send-icon.svg';
import successIcon from '../../assets/success-icon.svg';
import Spinner from '../components/Spinner';
import { likert } from '../config';

const facesArr = [
  {
    text: 'Muy mala',
    imgGreyFace: require('../../assets/faces/muy-mala.svg'),
    imgYellowFace: require('../../assets/faces/muy-mala-hover.svg'),
    value: 1,
  },
  {
    text: 'Mala',
    imgGreyFace: require('../../assets/faces/mala.svg'),
    imgYellowFace: require('../../assets/faces/mala-hover.svg'),
    value: 2,
  },
  {
    text: 'Neutral',
    imgGreyFace: require('../../assets/faces/neutral.svg'),
    imgYellowFace: require('../../assets/faces/neutral-hover.svg'),
    value: 3,
  },
  {
    text: 'Buena',
    imgGreyFace: require('../../assets/faces/buena.svg'),
    imgYellowFace: require('../../assets/faces/buena-hover.svg'),
    value: 4,
  },
  {
    text: 'Muy buena',
    imgGreyFace: require('../../assets/faces/muy-buena.svg'),
    imgYellowFace: require('../../assets/faces/muy-buena-hover.svg'),
    value: 5,
  },
];

const Face = ({ text, imgGreyFace, imgYellowFace, onClick }) => {
  return (
    <button onClick={onClick}>
      <img className="face" src={imgGreyFace} alt={text} />
      <img className="hoverFace" src={imgYellowFace} alt={text} />
      <img className="errorFace" src={imgErrorFace} alt="Error" />
      <span className="ff-text">{text}</span>

      <style jsx>{`
        button {
          display: flex;
          flex-direction: column;
          text-align: center;
          align-items: center;
          width: 78px;
          margin-left: 5px;
          background-color: transparent;
          border: none;
          cursor: default;
          position: relative;
        }
        button:first-child {
          margin-left: 0;
        }
        button img {
          width: 50px;
          height: 50px;
          transform: scale(0.9);
        }
        @media (max-width: 992px) {
          button img {
            width: 34px;
            height: 34px;
          }
        }
        button img:nth-child(1) {
          position: relative;
          z-index: 2;
          transition: 0.3s all;
        }
        button img:nth-child(1):hover {
          opacity: 0;
        }
        button img:nth-child(1):hover + .hoverFace {
          opacity: 1;
        }
        button .face,
        button .hoverFace {
          cursor: pointer;
        }
        button .hoverFace {
          position: absolute;
          z-index: 1;
        }
        button .ieHoverFace {
          transform: translate(-50%, -100%) scale(0.9);
          left: 50%;
        }
        button .opacity {
          opacity: 0;
        }
        button .faceShadow {
          filter: drop-shadow(0 2px 2px rgba(237, 203, 147, 0.9));
        }
        button span {
          font-size: 13px;
          color: #56504c;
        }
        @media (max-width: 992px) {
          button span {
            margin-top: 5px;
            font-size: 11.6px;
          }
        }
        .errorFace {
          display: none;
        }
      `}</style>
    </button>
  );
};

const LikertSlider = ({ likertReq }) => {
  const textArea = useRef(null);

  const [faceValue, setFaceValue] = useState(0);
  const [showTextArea, setShowTextArea] = useState(false);
  const [showTitle, setShowTitle] = useState(true);
  const [error, setError] = useState(false);
  const [sentFeedback, setSentFeedback] = useState(false);
  const [counterCaracter, setCounterCaracter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const clickFace = (e, faceValue) => {
    if (!sentFeedback) {
      e.persist();
      (async () => {
        setFaceValue(faceValue);
        setShowTextArea(true);
        const faces = document.querySelectorAll('.face');
        faces.forEach(f => f.classList.remove('opacity'));
        e.target.classList.add('opacity');
      })();
    }
  };

  const sendFeedback = () => {
    setIsLoading(true);

    const req = {
      tipoDocumento: 'CI', // likertReq.tipo_cedula no es valido y no se pide otro tipo de documento asi que queda fijo
      numeroDocumento: likertReq.numero_cedula,
      idSolicitud: likertReq.solicitudId,
      puntaje: faceValue,
      comentario: textArea.current.value,
    };

    likert(req)
      .then(res => {
        if (res && res.status === 200 && res.statusText === 'OK') {
          successSentFeedback();
          setIsLoading(false);
        } else {
          errorSentFeedback();
          setIsLoading(false);
        }
      })
      .catch(err => {
        errorSentFeedback();
        setIsLoading(false);
      });
  };

  const successSentFeedback = () => {
    setShowTextArea(false);
    setShowTitle(false);
    setSentFeedback(true);
    document.querySelector('.likertSliderSuccess').classList.remove('hide');
  };

  const errorSentFeedback = () => {
    setShowTextArea(false);
    setShowTitle(false);
    setSentFeedback(true);
    document.querySelector('.likertSliderError').classList.remove('hide');

    const faces = document.querySelectorAll('.face');
    faces.forEach(f => (f.style.display = 'none'));

    const hoverFaces = document.querySelectorAll('.hoverFace');
    hoverFaces.forEach(f => (f.style.display = 'none'));

    const errorFaces = document.querySelectorAll('.errorFace');
    errorFaces.forEach(f => (f.style.display = 'initial'));
  };

  const retrySendFeedback = () => {
    setShowTitle(true);
    setSentFeedback(false);
    document.querySelector('.likertSliderError').classList.add('hide');

    const yellowFaces = document.querySelectorAll('.face');
    yellowFaces.forEach(f => f.classList.remove('opacity'));

    const faces = document.querySelectorAll('.face');
    faces.forEach(f => (f.style.display = 'initial'));

    const hoverFaces = document.querySelectorAll('.hoverFace');
    hoverFaces.forEach(f => (f.style.display = 'initial'));

    const errorFaces = document.querySelectorAll('.errorFace');
    errorFaces.forEach(f => (f.style.display = 'none'));
  };

  const textAreaHeight = e => {
    e.currentTarget.style.height = '1px';
    e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px';
  };

  return (
    <div id="likertSlider">
      <div className="wrapperLikert">
        <p
          className="ff-display likertSliderTitle"
          style={{ display: showTitle ? 'block' : 'none' }}
        >
          Contanos cómo fue tu experiencia solicitando tu tarjeta
        </p>
        <div className="likertSliderMsg likertSliderSuccess hide">
          <p className="ff-display">
            <img className="msgIcon" src={successIcon} alt="Exito" />
            Gracias por tu valoración
          </p>
          <span className="ff-display">
            Nos ayuda a mejorar la experiencia de todos los usuarios.
          </span>
        </div>
        <div className="likertSliderMsg likertSliderError hide">
          <p className="ff-display">
            <img className="msgIcon" src={errorIcon} alt="Error" />
            No pudimos enviar tu valoración
          </p>
          <span className="ff-display">
            No todo está perdido, siempre podés{' '}
            <button onClick={() => retrySendFeedback()}>Reintentar enviar tu valoración</button>
          </span>
        </div>
        <div id="faces">
          {facesArr.map(f => (
            <Face
              key={f.value}
              text={f.text}
              imgGreyFace={f.imgGreyFace}
              imgYellowFace={f.imgYellowFace}
              onClick={e => clickFace(e, f.value)}
            />
          ))}
        </div>
      </div>
      <div id="likertSliderText" style={{ display: showTextArea ? 'block' : 'none' }}>
        <textarea
          ref={textArea}
          id="likertSliderComment"
          className="ff-text"
          cols="1"
          rows="1"
          placeholder="Podés dejarnos un comentario"
          maxLength="150"
          onChange={() => setCounterCaracter(textArea.current.value.length)}
          onKeyUp={e => textAreaHeight(e)}
        ></textarea>
        <p className="likertSliderCharacters">{`${counterCaracter}/150`}</p>
        <div id="likertSliderBtn">
          <button id="likertSliderSend" className="ff-display" onClick={() => sendFeedback()}>
            {isLoading ? (
              <Spinner color="white" size={10} />
            ) : (
              <>
                <img src={sendIcon} alt="Enviar" />
                Enviar
              </>
            )}
          </button>
        </div>
      </div>

      <style jsx>{`
        #likertSlider {
          background-color: white;
          padding: 24px 32px 0;
          margin: 24px 0 48px;
          box-shadow: 0px 8px 17px rgba(86, 80, 76, 0.04), 0px 2px 17px rgba(86, 80, 76, 0.04),
            0px 1px 4px rgba(86, 80, 76, 0.04);
          border-radius: 4px;
        }
        @media (max-width: 992px) {
          #likertSlider {
            padding: 10px 16px 0;
          }
        }
        #likertSlider .wrapperLikert:first-child {
          display: flex;
          justify-content: space-between;
          padding-bottom: 24px;
        }
        @media (max-width: 992px) {
          #likertSlider .wrapperLikert:first-child {
            flex-direction: column;
          }
        }
        #likertSlider .wrapperLikert:nth-child(2) {
          display: flex;
          flex-direction: column;
        }
        #likertSlider .wrapperLikert:nth-child(2) input {
          width: 100%;
          border: none;
          border-bottom: 1px solid rgba(86, 80, 76, 0.5);
        }
        #likertSlider .likertSliderTitle {
          font-size: 17px;
          font-weight: 700;
          color: #252220;
          line-height: 27px;
          margin-top: 10px;
        }
        @media (max-width: 992px) {
          #likertSlider .likertSliderTitle {
            margin-bottom: 30px;
          }
        }
        #likertSlider #faces {
          display: flex;
        }
        #likertSlider #likertSliderText {
          display: none;
          margin-top: 16px;
          padding-bottom: 16px;
        }
        @media (max-width: 992px) {
          #likertSlider #likertSliderText {
            margin-top: 18px;
          }
        }
        #likertSlider #likertSliderText #likertSliderComment {
          width: 100%;
          border: none;
          border-bottom: 1px solid rgba(86, 80, 76, 0.5);
          background-color: transparent;
          padding: 0 60px 8px 0;
          position: relative;
          z-index: 2;
          resize: none;
          overflow-y: hidden;
          font-family: 'ItauText', sans-serif;
        }
        #likertSlider #likertSliderText .likertSliderCharacters {
          text-align: right;
          transform: translateY(calc(-100% - 12px));
          user-select: none;
          font-size: 14px;
          margin: 0;
        }
        #likertSlider #likertSliderText #likertSliderBtn .likertSliderError {
          padding: 6px 0;
          line-height: 18px;
          font-size: 12px;
          color: #b71c1c;
          justify-content: flex-end;
          align-items: center;
          margin-top: 25px;
          display: none;
        }
        #likertSlider #likertSliderText #likertSliderBtn .likertSliderError img {
          margin-left: 8px;
        }
        #likertSlider #likertSliderText #likertSliderBtn button {
          color: #007ab7;
          border: 1px solid #007ab7;
          border-radius: 4px;
          background-color: transparent;
          padding: 6px 14px;
          line-height: 27px;
          font-weight: 700;
          display: flex;
          align-items: center;
          margin: 0 0 0 auto;
          transition: 0.3s all;
          cursor: pointer;
        }
        #likertSlider #likertSliderText #likertSliderBtn button:hover {
          background-color: #007ab7;
          color: white;
        }
        #likertSlider #likertSliderText #likertSliderBtn button:hover img {
          filter: brightness(0) invert(1);
        }
        #likertSlider #likertSliderText #likertSliderBtn button img {
          margin-right: 11px;
        }
        #likertSlider #likertSliderText #likertSliderBtn span.showError {
          display: flex;
        }
        #likertSlider #likertSliderText #likertSliderBtn button.showError {
          display: none;
        }
        #likertSlider #likertSliderText #likertSliderComment.showError {
          display: none;
        }
        #likertSlider .likertSliderMsg {
          font-size: 17px;
          font-weight: 700;
          margin: 10px 0 0 30px;
        }
        @media (max-width: 992px) {
          #likertSlider .likertSliderMsg {
            margin: 10px 0 20px 0;
          }
        }
        #likertSlider .likertSliderMsg p {
          display: flex;
          align-items: center;
          position: relative;
          margin: 0;
        }
        #likertSlider .likertSliderMsg p img {
          position: absolute;
          left: -30px;
        }
        @media (max-width: 992px) {
          #likertSlider .likertSliderMsg p img {
            position: relative;
            left: 0;
            margin-right: 6px;
          }
        }
        #likertSlider .likertSliderMsg span {
          font-size: 14px;
          font-weight: 400;
          color: #56504c;
        }
        #likertSlider .likertSliderMsg.hide {
          display: none;
        }
        #likertSlider .likertSliderSuccess {
          color: #007a47;
        }
        #likertSlider .likertSliderError {
          color: #b71c1c;
        }
        #likertSlider .likertSliderError button {
          color: #007ab7;
          border: none;
          background-color: transparent;
          padding: 0;
          transform: translateY(-5px);
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default LikertSlider;
